var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hugeicons:job-search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6758 28.3952H12.8065C8.0265 28.3952 5.63717 28.3952 4.15184 26.8818C2.6665 25.3685 2.6665 22.9325 2.6665 18.0618C2.6665 13.1912 2.6665 10.7552 4.15184 9.24185C5.63717 7.72852 8.0265 7.72852 12.8065 7.72852H17.8772C22.6572 7.72852 25.0478 7.72852 26.5332 9.24185C27.6758 10.4058 27.9385 12.1165 27.9998 15.0618",
    stroke: "white",
    strokeOpacity: 0.48,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.689 27.0922L29.333 29.7282M21.333 7.72819L21.1997 7.31486C20.5397 5.26152 20.2103 4.23486 19.425 3.64819C18.6383 3.06152 17.5957 3.06152 15.5063 3.06152H15.1557C13.069 3.06152 12.025 3.06152 11.2397 3.64819C10.453 4.23486 10.1237 5.26152 9.46367 7.31486L9.33301 7.72819M28.0703 23.7629C28.0809 23.1387 27.967 22.5187 27.7354 21.9391C27.5038 21.3594 27.1592 20.8316 26.7215 20.3865C26.2838 19.9414 25.7619 19.5879 25.1862 19.3466C24.6105 19.1053 23.9926 18.981 23.3683 18.981C22.7441 18.981 22.1261 19.1053 21.5504 19.3466C20.9747 19.5879 20.4528 19.9414 20.0152 20.3865C19.5775 20.8316 19.2328 21.3594 19.0013 21.9391C18.7697 22.5187 18.6558 23.1387 18.6663 23.7629C18.6871 24.9962 19.1916 26.172 20.0712 27.0368C20.9507 27.9017 22.1348 28.3863 23.3683 28.3863C24.6019 28.3863 25.786 27.9017 26.6655 27.0368C27.5451 26.172 28.0496 24.9962 28.0703 23.7629Z",
    stroke: "white",
    strokeOpacity: 0.48,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2d0f4b1e32c3f3455a978c54f4ab0909.svg";
export { ForwardRef as ReactComponent };